import { CredentialTable } from "./credential-table";
import { type CredentialOpening } from "./credential-intent";
import type { CredentialTarget } from "./credentials.queries";

export function CredentialsRegion({
  target,
  onOpen,
}: {
  target: CredentialTarget;
  onOpen(opening: CredentialOpening): void;
}) {
  return (
    <CredentialTable
      target={target}
      headingLevel={target.kind === "user" ? 2 : 4}
      title={
        target.kind === "user" ? "Account credentials" : "Player credentials"
      }
      description={
        target.kind === "user"
          ? "Keys that let the Softmax command-line tool, or an agent you run, act as your account. Keep them secret."
          : "Each credential acts only as this player."
      }
      onOpen={onOpen}
    />
  );
}
